import { SolRectangle } from '../services/popover.service';

export class PopoverTools {
  private static readonly scrollKeys: string[] = [
    'PageUp',
    'PageDown',
    'Home',
    'End',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    ' ',
  ];
  private static readonly keyConsumerSelector = 'input, textarea, select, [contenteditable]';

  /**
   * Returns true if the bounds have dimensions.
   */
  public static isValidParent(bounds: SolRectangle): boolean {
    return bounds.x > 0 || bounds.y > 0 || bounds.width > 0 || bounds.height > 0;
  }

  /** Whether the browser would scroll as this event's default — a key only when its element leaves it alone. */
  public static scrollsPage(event: WheelEvent | TouchEvent | KeyboardEvent): boolean {
    if (!('key' in event)) {
      return true;
    }
    return PopoverTools.scrollKeys.includes(event.key) && !PopoverTools.consumesKey(event);
  }

  private static consumesKey(event: KeyboardEvent): boolean {
    const target = event.target;
    if (!(target instanceof HTMLElement)) {
      return false;
    }
    return target.matches(PopoverTools.keyConsumerSelector) || (event.key === ' ' && target.matches('button'));
  }
}
